import { render, staticRenderFns } from "./LandingResearcherPage.vue?vue&type=template&id=eaa8230a"
import script from "./LandingResearcherPage.vue?vue&type=script&lang=js"
export * from "./LandingResearcherPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports